import {
	OneOnOneTeamRoleType,
	TeamMemberStatusType,
	TeamRoleType,
	TeamType
} from "@teaming/common-enums";

const oneOnOneTeamRoleLookup = {
	"": OneOnOneTeamRoleType.MANAGER,
	[ OneOnOneTeamRoleType.PEER ]: OneOnOneTeamRoleType.PEER,
	[ OneOnOneTeamRoleType.MANAGER ]: OneOnOneTeamRoleType.REPORT,
	[ OneOnOneTeamRoleType.REPORT ]: OneOnOneTeamRoleType.MANAGER,
};

export const materializeOneOnOne = ( { initiator, invitee, team = {}, skipInviteEmail = false, } ) => {
	const { id: relatedTeamId, } = team;

	const {
		name: initiatorName,
		email: initiatorEmail,
	} = initiator;

	const {
		name: inviteeName,
		email: inviteeEmail,
		role: inviteeTeamRole,
		isRegisteredUser: isInviteeRegisteredUser,
		deferInvitation: isInvitationDeferred,
	} = invitee;

	let { oneOnOneRole: inviteeOneOnOneRole = OneOnOneTeamRoleType.REPORT, } = invitee;

	// this oneOnOne is being created within the context of a team
	// - during onboarding
	// - on an existing team page
	if ( relatedTeamId && isInviteeRegisteredUser ) {
		// assumes that the initiator is a LEAD
		inviteeOneOnOneRole = inviteeTeamRole === TeamRoleType.LEAD ?
			OneOnOneTeamRoleType.PEER :
			OneOnOneTeamRoleType.REPORT;
	}

	const initiatorOneOnOneRole = oneOnOneTeamRoleLookup[ inviteeOneOnOneRole ];

	let inviteeStatus = TeamMemberStatusType.DEFERRED;
	if ( !isInvitationDeferred ) {
		inviteeStatus = isInviteeRegisteredUser ?
			TeamMemberStatusType.ACTIVE :
			TeamMemberStatusType.INVITED;
	}

	const oneOnOne = {
		name: `${ initiatorName || initiatorEmail } : ${ inviteeName || inviteeEmail }`,
		type: TeamType.ONE_ON_ONE,
		members: [
			// invitee
			{
				email: inviteeEmail,
				role: inviteeOneOnOneRole,
				status: inviteeStatus,
			},
			// initiator
			{
				email: initiatorEmail,
				role: initiatorOneOnOneRole,
				status: TeamMemberStatusType.ACTIVE,
			},
		],
	};

	if ( relatedTeamId ) {
		oneOnOne.relatedTeamId = relatedTeamId;
	}

	if ( skipInviteEmail ) {
		oneOnOne.skipInviteEmail = !!skipInviteEmail;
	}

	return oneOnOne;
};

export const getRelativeOneOnOneMembers = ( oneOnOne, thisUserId ) => {
	const { members, } = oneOnOne;
	const thisMember = members.find( member => member.personId === thisUserId ) || undefined;
	const otherMember = oneOnOne.members.find( member => member.personId !== thisUserId ) || undefined;
	return { thisMember, otherMember, };
};

/** @deprecated this should come from the API now */
export const deriveOneOnOneName = ( oneOnOne, thisUserId ) => {
	const { otherMember, } = getRelativeOneOnOneMembers( oneOnOne, thisUserId );
	return otherMember?.displayName || "";
};

export const computeOneOnOneRoles = ( oneOnOne, personId, newRole ) => {
	return oneOnOne.members.reduce( ( memberRoleMap, member ) => {
		if ( newRole === OneOnOneTeamRoleType.PEER ) {
			// set all members to PEERs
			memberRoleMap[ member.personId ] = newRole;
		} else if ( member.personId === personId ) {
			// assign the new role to the specified member
			memberRoleMap[ member.personId ] = newRole;
		} else {
			// invert the other member's role
			memberRoleMap[ member.personId ] = ( newRole === OneOnOneTeamRoleType.MANAGER ) ?
				OneOnOneTeamRoleType.REPORT :
				OneOnOneTeamRoleType.MANAGER;
		}
		return memberRoleMap;
	}, {} );
};
